import { useState , useEffect, useCallback} from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./components/global/Topbar";
import Sidebar from "./components/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Contacts from "./scenes/contacts";
import Home from "./scenes/home";
import Store from "./scenes/store";

import FAQ from "./scenes/faq";
import Profile from "./scenes/user/profile";
import UserDetail from "./scenes/user/detail";
import Register from "./scenes/user/register";
import NotFound from "./scenes/global/NotFound";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { useDispatch, useSelector } from "react-redux";
import UserSession from "./scenes/admin/user_session";
import UserRoles from "./scenes/user_roles";
import Login from "./components/user/Login";
import { logout } from "./slices/auth";
import { PrivateRoute } from "./components/global/PrivateRoute";
import UserList from "./scenes/user/list";
import CollectionList from "./scenes/admin/collections/list";
import CollectionDetail from "./scenes/admin/collections/detail";
import Forbidden from "./scenes/global/Forbidden";
import Collections from "./scenes/collections/List"
import Signs from "./scenes/signs/list"
import Sign from "./scenes/signs/sign"

import Commands from "./scenes/admin/commands";
import Messages from "./scenes/admin/messages";

import AdminSignList from "./scenes/admin/signs/list";
import AdminSignDetail from "./scenes/admin/signs/detail";

import ImageEditor from "./components/imageEditor/Editor";


function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const { user: currentUser } = useSelector((state) => state.auth);

  const dispatch = useDispatch();


  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);


  return (

    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">

        <Sidebar isSidebar={isSidebar} />
        
          <main className="content">

          <Topbar setIsSidebar={setIsSidebar} />

            <Routes>

              <Route path="/" element={<Home />} />

              <Route path="/admin/messages" element={ <PrivateRoute><Messages /></PrivateRoute>} />
              <Route path="/admin/commands" element={ <PrivateRoute><Commands /></PrivateRoute>} />
              <Route path="/admin/user_sessions" element={ <PrivateRoute role="SUPER_ADMIN"><UserSession /></PrivateRoute>} />
              <Route path="/user_roles" element={ <PrivateRoute><UserRoles /></PrivateRoute>} />
              <Route path="/user" element={ <PrivateRoute><UserList /></PrivateRoute>} />
              <Route path="/user/:username" element={<PrivateRoute><UserDetail /></PrivateRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
              <Route path="/register" element={<Register />} />

              <Route path="/admin/collection" element={ <PrivateRoute><CollectionList/></PrivateRoute>} />
              <Route path="/admin/collection/:id" element={<PrivateRoute><CollectionDetail /></PrivateRoute>} />
              

              <Route path="/admin/sign" element={ <PrivateRoute><AdminSignList/></PrivateRoute>} />
              <Route path="/admin/sign/:id" element={<PrivateRoute><AdminSignDetail /></PrivateRoute>} />

              <Route path="/store" element={<Store />} />
              
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/collections" element={ <PrivateRoute><Collections/></PrivateRoute>} />
              <Route path="/sign" element={ <PrivateRoute><Signs/></PrivateRoute>} />
              <Route path="/sign/:id" element={ <PrivateRoute><Sign/></PrivateRoute>} />


              <Route path="/contacts" element={<Contacts />} />


              <Route path="/faq" element={<FAQ />} />

              <Route path='/forbidden' element={<Forbidden />} />
              <Route path='*' element={<NotFound />} />


            </Routes>

            {/* <AuthVerify logOut={logOut}/> */}

          </main>

        </div>

      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
